/**
 * The sport's competition tree.
 *
 * One request for the whole shape, which changes only when someone adds a node.
 */

import { useParams } from "react-router-dom";

import { Tree } from "@/components/competitions/Tree";
import { Crumbs, PageHead, Problem } from "@/components/kit";
import { getCompetitionTree } from "@/lib/api/client";
import { displayName } from "@/lib/format";
import { useApi } from "@/spa/useApi";

export function CompetitionsPage() {
  const { sport = "" } = useParams<{ sport: string }>();
  const { data: tree, loading, error } = useApi(
    () => getCompetitionTree(sport),
    [sport],
    "failed to load",
  );

  if (error) {
    return (
      <Problem>
        Could not load {sport}&apos;s competitions: {error}
      </Problem>
    );
  }
  if (!tree) return <PageHead title="Competitions" note={loading ? "Loading…" : ""} />;

  return (
    <>
      <Crumbs
        trail={[
          { label: "Sports", href: "/sports" },
          { label: displayName(sport), href: `/${sport}` },
          { label: "Competitions" },
        ]}
      />
      <Tree sport={sport} tree={tree} />
    </>
  );
}
